export default {
	xAxis: {
		doubleRow: {
			minutes: {
				default: '%X', // 6:00:00 PM
				first: '%x %A' // 5/17/2024 Friday
			},
			hours: {
				default: '%X', // 6:00:00 PM
				first: '%x %A' // 5/17/2024 Friday
			},
			days: {
				default: '%e', // 17
				first: '%b %Y', // May 2024
				firstAlt: '%x %A', // 5/17/2024 Friday
				intraday: '%x %A' // 5/17/2024 Friday
			},
			weeks: {
				default: '%-m/%-d', // 5/17
				first: '%b %Y', // May 2024
				firstAlt: '%b %Y' // May 2024
			},
			months: {
				default: '%b', // May
				first: '%Y', // 2024
				firstAlt: '%b %Y' // May 2024
			},
			years: {
				default: '%Y', // 2024
				first: '%Y' // 2024
			}
		},
		singleRow: {
			minutes: {
				default: '%X', // 3:00:00 PM
				first: '%-m/%-d', // 5/17
				firstAlt: '%X' // 5/17
			},
			hours: {
				default: '%X', // 3:00:00 PM
				first: '%-m/%-d', // 5/17
				firstAlt: '%X' // 5/17
			},
			days: {
				default: '%e', // 17
				first: '%-m/%-d' // 5/17
			},
			weeks: {
				default: '%-m/%-d', // 5/17
				first: '%b %Y', // May 2024
				firstAlt: '%b %Y' // May 2024
			},
			months: {
				default: '%b', // May
				first: '%Y', // 2024
				firstAlt: '%b %Y' // May 2024
			},
			years: {
				default: '%Y', // 2024
				first: '%Y' // 2024
			}
		}
	}
};
